import AdviserExportIntegrationTypeEnum from '@constants/enums/adviser/exportIntegrationType';

import i18n from '@plugins/i18n';

import { Collection, AdviserExportIntegration, Adviser } from '@/models';

export class AdviserExportIntegrationCollection extends Collection {
    static type = 'AdviserExportIntegrationCollection';
    static endpoint = Adviser.api.integrations;
    static model = AdviserExportIntegration;

    static fields() {
        return {
            ...super.fields(),
            adviser_id: this.string(null).nullable(),
            adviser: this.belongsTo(Adviser, 'adviser_id')
        };
    }

    get preset_filters() {
        let filters = {};

        if (this.adviser_id) {
            filters.adviser_id = this.filterOperator('is') + ':' + this.adviser_id;
        }

        return filters;
    }

    get headers() {
        return [
            this.createHeader('integration', i18n.t('integration'), {
                format: 'enum',
                filterable: true,
                enum: AdviserExportIntegrationTypeEnum,
                enumA11yKey: 'enums.adviser_export_integration_type',
                width: '100%',
                sortable: true
            })
        ];
    }
}

export default AdviserExportIntegrationCollection;
